<template>
  <div>
    <div class="grid-x grid-padding-y">
      <div class="large-12 cell">
        <p class="text-center">&nbsp;</p>
      </div>
    </div> 
    <div class="grid-container container first">
      <div class="grid-x grid-padding-x layout">
        <div class="cell medium-6 large-4 large-centered">
          <form  data-abide novalidate ref="f" class="" autocomplete="new-password">
            <div class="card-section">

               <div class="text-center h4">
                <div to="" style="color: inherit;">
                  Email Sent
                </div>
              </div>
              <div class="padding-top-1 padding-bottom-1">
<p style="font-size: 1rem;">
                  A password reset token has been sent to your email. Please check your email.
                </p>
              </div>

              <label>
                <input
                        name="Token"
                        type="text"
                        placeholder="Reset token"
                        autofocus
                        v-model="model.Token"
                        required
                        autocomplete="new-password"
                />
                <span class="form-error">
                  This field is required.
                </span>
              </label>

              <p style="clear: both;">&nbsp;</p>
              <label>
                <input
                        id="NewPassword"
                        name="NewPassword"
                        type="password"
                        placeholder="New Password"
                        autofocus
                        v-model="model.NewPassword"
                        required
                        autocomplete="new-password"
                />
                <span class="form-error">
                  This field is required.
                </span>
              </label>
              <p style="clear: both;">&nbsp;</p>
              <label>
                <input
                        id="VerifyNewPassword"
                        name="VerifyNewPassword"
                        type="password"
                        placeholder="Verify New Password"
                        autofocus
                        v-model="model.VerifyNewPassword"
                        required
                />
                <span v-show="model.VerifyNewPassword.length > 0 && !pwdMatch" style="margin-top: -0.5rem;
    padding-bottom: 1rem;
    font-size: 0.75rem;
    font-weight: bold;
    color: #cc4b37;">
                  Your password and confirmation password do not match.
                </span>
                <span class="form-error">
                  This field is required.
                </span>
              </label>


              <p style="clear: both;">&nbsp;</p>
              <p>
                <input
                  id="login"
                  name="login"
                  type="submit"
                  class="button expanded radius large"
                  value="Reset My Password"
                />
              </p>
            </div>
          </form>
        </div>
      </div>
    </div>

    <div class="container"></div>
  </div>
</template>

<script>
 import accountRepository from "@/app.account/services/main-service.js";

export default {
  name: "appForgotPassword",
  mixins: [require("@/app/mixins/foundation")],
  data() {
    return {
      model: {
          Token : "",
          NewPassword : "",
          VerifyNewPassword : "",
          Email : ""
      },
      pwdMatch: true,

       isValid: false,
      loading: false,
      errored: false,
    };
  },
  mounted () {
    let _this = this;

    $('#NewPassword, #VerifyNewPassword').on('keyup', function () {
  if ($('#NewPassword').val() == $('#VerifyNewPassword').val()) {
    //$('#message').html('Matching').css('color', 'green');
    _this.pwdMatch = true;
  } else 
    //$('#message').html('Not Matching').css('color', 'red');
    _this.pwdMatch = false;
});


      this.model.Email = this.$route.params.email;
    

    $(this.$refs.f)
      .on("invalid.zf.abide", function() {
        _this.isValid = false;
      })
      .on("formvalid.zf.abide", function() {
        _this.isValid = true;
      })
      .on("submit", function(ev) {
        ev.preventDefault();

        if (_this.isValid) {
          _this.onSubmit();
        } else {
          // console.log("error");
        }
      });


    window.scrollTo(0,0);
  },
  methods: {
    async onSubmit() {
      this.$refs.f.login.disabled = true;
      try {
        await accountRepository.resetPassword(this.model);
        this.$router.push({name:'login'});
      } catch (error) {
        this.errored = true;
      } finally {
        this.loading = this.$refs.f.login.disabled = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.layout {
  padding-top: 1.5rem;
  .large-centered {
    margin: 0 auto;
  }
}
.banner-description{
  background-image: linear-gradient(to bottom right, #cec9c9, white);
}
</style>
